import axios from 'axios';
import { REACT_APP_BASE_API_URL } from '../../environments/'

const NetworkProvider = () => {
  const instance = axios.create({
    baseURL: REACT_APP_BASE_API_URL
  });

  instance.interceptors.request.use(
    async config => {
      const localStoreageData = JSON.parse(localStorage.getItem('user-storage'))
      const locale = JSON.parse(localStorage.getItem('locale-storage'))
      const accessToken = localStoreageData.state.accessToken
      const langCode = locale.state.code
      if (accessToken && langCode) {
        config.headers = { 
          ...config.headers,
          'Authorization': `Bearer ${accessToken}`
        }
      }

      if (langCode) {
        config.headers = {
          ...config.headers,
          'Language': langCode
        }
      }
      return config;
    },
    error => {
      Promise.reject(error)
  });
  
  instance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    console.error(error)
    if (error.response?.status === 401 && error.response?.config?.url !== "/api/v1/login") {
      return window.location.href = '/logout';
    }
    return Promise.reject(error);
  });
  
  const get = async (url) => instance.get(url)

  const post = async (url, payload) => instance.post(url, payload)

  const put = async (url, payload) => instance.put(url, payload)

  const patch = async (url, payload) => instance.patch(url, payload)

  return {
    get,
    post,
    put,
    patch,
  }
}

export default NetworkProvider;